export const ERROR_RECEIVE = 'ERROR_RECEIVE'

export const THIRDPAYLOGIN_REQUEST = 'THIRDPAYLOGIN_REQUEST'
export const THIRDPAYLOGIN_RECEIVE = 'THIRDPAYLOGIN_RECEIVE'

export const GETCURRENCYGEAR_REQUEST = 'GETCURRENCYGEAR_REQUEST'
export const GETCURRENCYGEAR_RECEIVE = 'GETCURRENCYGEAR_RECEIVE'

export const GETALLPAYMODE_REQUEST = 'GETALLPAYMODE_REQUEST'
export const GETALLPAYMODE_RECEIVE = 'GETALLPAYMODE_RECEIVE'

export const SERVERIAPLIST_REQUEST = 'SERVERIAPLIST_REQUEST'
export const SERVERIAPLIST_RECEIVE = 'SERVERIAPLIST_RECEIVE'

export const GETTHIRDPAYORDERLIST_REQUEST = 'GETTHIRDPAYORDERLIST_REQUEST'
export const GETTHIRDPAYORDERLIST_RECEIVE = 'GETTHIRDPAYORDERLIST_RECEIVE'

export const CREATETHIRDPAYORDER_REQUEST = 'CREATETHIRDPAYORDER_REQUEST'
export const CREATETHIRDPAYORDER_RECEIVE = 'CREATETHIRDPAYORDER_RECEIVE'

export const VERIFYTHIRDPAYORDER_REQUEST = 'VERIFYTHIRDPAYORDER_REQUEST'
export const VERIFYTHIRDPAYORDER_RECEIVE = 'VERIFYTHIRDPAYORDER_RECEIVE'

export const THIRDPAYORDERREQUESTPAY_REQUEST = 'THIRDPAYORDERREQUESTPAY_REQUEST'
export const THIRDPAYORDERREQUESTPAY_RECEIVE = 'THIRDPAYORDERREQUESTPAY_RECEIVE'

export const GETDEFAULTPAYMENT_REQUEST = 'GETDEFAULTPAYMENT_REQUEST'
export const GETDEFAULTPAYMENT_RECEIVE = 'GETDEFAULTPAYMENT_RECEIVE'

export const CHECKROLESTOKEN_REQUEST = 'CHECKROLESTOKEN_REQUEST'
export const CHECKROLESTOKEN_RECEIVE = 'CHECKROLESTOKEN_RECEIVE'

export const ORDERSUBLIST_REQUEST = 'ORDERSUBLIST_REQUEST'
export const ORDERSUBLIST_RECEIVE = 'ORDERSUBLIST_RECEIVE'

export const GETUSERPOINTDATA_REQUEST = 'GETUSERPOINTDATA_REQUEST'
export const GETUSERPOINTDATA_RECEIVE = 'GETUSERPOINTDATA_RECEIVE'

export const GETUSERPOINTRULE_REQUEST = 'GETUSERPOINTRULE_REQUEST'
export const GETUSERPOINTRULE_RECEIVE = 'GETUSERPOINTRULE_RECEIVE'

export const GETUSERPOINTSWITCH_REQUEST = 'GETUSERPOINTSWITCH_REQUEST'
export const GETUSERPOINTSWITCH_RECEIVE = 'GETUSERPOINTSWITCH_RECEIVE'

export const GETEMAILCODE_REQUEST = 'GETEMAILCODE_REQUEST'
export const GETEMAILCODE_RECEIVE = 'GETEMAILCODE_RECEIVE'

export const SETPAYEMAIL_REQUEST = 'SETPAYEMAIL_REQUEST'
export const SETPAYEMAIL_RECEIVE = 'SETPAYEMAIL_RECEIVE'

export const GETPOINTINIT_REQUEST = 'GETPOINTINIT_REQUEST'
export const GETPOINTINIT_RECEIVE = 'GETPOINTINIT_RECEIVE'

export const GETPAYPWDFLAG_REQUEST = 'GETPAYPWDFLAG_REQUEST'
export const GETPAYPWDFLAG_RECEIVE = 'GETPAYPWDFLAG_RECEIVE'

export const GETEMAILFLAG_REQUEST = 'GETEMAILFLAG_REQUEST'
export const GETEMAILFLAG_RECEIVE = 'GETEMAILFLAG_RECEIVE'

export const SETPAYPWD_REQUEST = 'SETPAYPWD_REQUEST'
export const SETPAYPWD_RECEIVE = 'SETPAYPWD_RECEIVE'

export const CHANGEPAYPWD_REQUEST = 'CHANGEPAYPWD_REQUEST'
export const CHANGEPAYPWD_RECEIVE = 'CHANGEPAYPWD_RECEIVE'

export const GETUSERPAYEMAIL_REQUEST = 'GETUSERPAYEMAIL_REQUEST'
export const GETUSERPAYEMAIL_RECEIVE = 'GETUSERPAYEMAIL_RECEIVE'

export const CHECKPAYPWD_REQUEST = 'CHECKPAYPWD_REQUEST'
export const CHECKPAYPWD_RECEIVE = 'CHECKPAYPWD_RECEIVE'

export const CHECKPAYEMAIL_REQUEST = 'CHECKPAYEMAIL_REQUEST'
export const CHECKPAYEMAIL_RECEIVE = 'CHECKPAYEMAIL_RECEIVE'

export const GETVERSION_REQUEST = 'GETVERSION_REQUEST'
export const GETVERSION_RECEIVE = 'GETVERSION_RECEIVE'

export const GETPCINFO_REQUEST = 'GETPCINFO_REQUEST'
export const GETPCINFO_RECEIVE = 'GETPCINFO_RECEIVE'

export const GETPCCOUNTRY_REQUEST = 'GETPCCOUNTRY_REQUEST'
export const GETPCCOUNTRY_RECEIVE = 'GETPCCOUNTRY_RECEIVE'

export const GETPCALLCOUNTRY_REQUEST = 'GETPCALLCOUNTRY_REQUEST'
export const GETPCALLCOUNTRY_RECEIVE = 'GETPCALLCOUNTRY_RECEIVE'

export const GETPCPAYM_REQUEST = 'GETPCPAYM_REQUEST'
export const GETPCPAYM_RECEIVE = 'GETPCPAYM_RECEIVE'

export const GETPCGEAR_REQUEST = 'GETPCGEAR_REQUEST'
export const GETPCGEAR_RECEIVE = 'GETPCGEAR_RECEIVE'

export const GETALLGEAR_REQUEST = 'GETALLGEAR_REQUEST'
export const GETALLGEAR_RECEIVE = 'GETALLGEAR_RECEIVE'

export const INIT = 'INIT'

export const GETWEBREGION_REQUEST = 'GETWEBREGION_REQUEST'
export const GETWEBREGION_RECEIVE = 'GETWEBREGION_RECEIVE'

export const GETWEBAPPINFO_REQUEST = 'GETWEBAPPINFO_REQUEST'
export const GETWEBAPPINFO_RECEIVE = 'GETWEBAPPINFO_RECEIVE'

export const GETWEBPAYMODE_REQUEST = 'GETWEBPAYMODE_REQUEST'
export const GETWEBPAYMODE_RECEIVE = 'GETWEBPAYMODE_RECEIVE'

export const GETWEBUNLOADGOODS_REQUEST = 'GETWEBUNLOADGOODS_REQUEST'
export const GETWEBUNLOADGOODS_RECEIVE = 'GETWEBUNLOADGOODS_RECEIVE'

export const GETWEBSWITCH_REQUEST = 'GETWEBSWITCH_REQUEST'
export const GETWEBSWITCH_RECEIVE = 'GETWEBSWITCH_RECEIVE'

export const GETNTLOGIN_REQUEST = 'GETNTLOGIN_REQUEST'
export const GETNTLOGIN_RECEIVE = 'GETNTLOGIN_RECEIVE'

export const GETSCANLOGIN_REQUEST = 'GETSCANLOGIN_REQUEST'
export const GETSCANLOGIN_RECEIVE = 'GETSCANLOGIN_RECEIVE'

export const GETGENECODE_REQUEST = 'GETGENECODE_REQUEST'
export const GETGENECODE_RECEIVE = 'GETGENECODE_RECEIVE'

export const GETGENEINFO_REQUEST = 'GETGENEINFO_REQUEST'
export const GETGENEINFO_RECEIVE = 'GETGENEINFO_RECEIVE'

export const GETWEBROLELIST_REQUEST = 'GETWEBROLELIST_REQUEST'
export const GETWEBROLELIST_RECEIVE = 'GETWEBROLELIST_RECEIVE'

export const getMallLoginStatus_REQUEST = 'getMallLoginStatus_REQUEST'
export const getMallLoginStatus_RECEIVE = 'getMallLoginStatus_RECEIVE'

export const GETWEBLOGOUT_REQUEST = 'GETWEBLOGOUT_REQUEST'
export const GETWEBLOGOUT_RECEIVE = 'GETWEBLOGOUT_RECEIVE'

export const GETCODELOGIN_REQUEST = 'GETCODELOGIN_REQUEST'
export const GETCODELOGIN_RECEIVE = 'GETCODELOGIN_RECEIVE'

export const GETVKPARAMS_REQUEST = 'GETVKPARAMS_REQUEST'
export const GETVKPARAMS_RECEIVE = 'GETVKPARAMS_RECEIVE'

export const GETVKCODELOGIN_REQUEST = 'GETVKCODELOGIN_REQUEST'
export const GETVKCODELOGIN_RECEIVE = 'GETVKCODELOGIN_RECEIVE'